import { Download, Sparkles, Loader2 } from "lucide-react";

interface ImportCTABannerProps {
  pageCount: number;
  documentCount: number;
  storeName: string;
  onImportAll: () => void;
  isLoading: boolean;
}

export default function ImportCTABanner({ pageCount, documentCount, storeName, onImportAll, isLoading }: ImportCTABannerProps) {
  const total = pageCount + documentCount;
  if (total <= 0) return null;

  // Build a "X pages and Y documents" phrase, dropping either half if it's zero
  const parts: string[] = [];
  if (pageCount > 0)     parts.push(`${pageCount} page${pageCount === 1 ? "" : "s"}`);
  if (documentCount > 0) parts.push(`${documentCount} document${documentCount === 1 ? "" : "s"}`);
  const summary = parts.join(" and ");

  return (
    <div className="bg-gradient-to-r from-blue-50 via-purple-50 to-blue-50 border border-blue-200 rounded-lg px-5 py-4 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm">
          <Sparkles className="w-5 h-5 text-blue-600" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-900">
            {summary} ready to import
          </p>
          <p className="text-xs text-gray-600 mt-0.5">
            Click Import to bring {total === 1 ? "it" : "them"} into <span className="font-medium">{storeName}</span> — files will be processed and become searchable.
          </p>
        </div>
      </div>
      <button
        onClick={onImportAll}
        disabled={isLoading}
        className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
        type="button"
      >
        {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
        Import all {total}
      </button>
    </div>
  );
}
